import { Component, OnInit } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { detailExpand } from "../../animations";

@Component({
  selector: "formly-object-type",
  template: `
    <div [class.ion-padding]="!to.description">
      <ion-item
        [class.big-item]="to.description"
        [lines]="'none'"
        [detail]="false"
      >
        <ion-label>
          <h1 *ngIf="to.label && to.description">{{ to.label }}</h1>
          <legend class="object-head" *ngIf="to.label && !to.description">
            {{ to.label }}
          </legend>
          <p class="descriptor" *ngIf="to.description">{{ to.description }}</p>
        </ion-label>
      </ion-item>
      <div
        class="alert alert-danger"
        role="alert"
        *ngIf="showError && formControl.errors"
      >
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
      <div class="overflow-hidden ion-padding-start">
        <formly-field
          [class.checkbox]="f.type === 'boolean'"
          *ngFor="let f of field.fieldGroup"
          [field]="f"
        ></formly-field>
      </div>
    </div>
    <ng-container *ngIf="to.description">
      <div *ngIf="expanded" class="ion-padding"></div>
      <div *ngIf="!expanded" class="divider"></div>
      <div *ngIf="expanded" class="ion-padding"></div>
    </ng-container>
  `,
  animations: [detailExpand],
})
export class ObjectTypeComponent extends FieldType implements OnInit {
  expanded: boolean;

  defaultOptions = {
    defaultValue: {},
  };
  ngOnInit() {
    this.field.fieldGroup = this.field.fieldGroup.map((f) => {
      if (f.type !== "boolean") {
        f.templateOptions.labelPosition = "stacked";
      }
      return f;
    });
  }
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
